<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <div class="divide-y-2 divide-gray-100">
            <div
                class="flex justify-between py-2"
                v-for="(currencyPoint, index) in widget.content.currencyPoints"
                :key="index"
            >
                <div>
                    <span>
                        {{ currencyPoint.type_display }}
                    </span>

                    <div v-if="currencyPoint.experienceable" class="inline-block">
                        <template v-if="currencyPoint.experienceable.gradePill">
                            <span
                                v-if="currencyPoint.experienceable.gradePill.absent"
                                class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800"
                            >
                                {{ $t('messages.absent') }}
                            </span>
                            <span
                                :class="currencyPoint.experienceable.gradePill.classes"
                                class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium"
                            >
                                {{ currencyPoint.experienceable.gradePill.letter }}
                            </span>
                        </template>
                    </div>
                </div>
                <div>
                    <div class="flex space-x-1">
                        <div>
                            <BadgePill color="green" v-if="currencyPoint.points">
                                {{ currencyPoint.points }}
                            </BadgePill>
                        </div>

                        <div>
                            <BadgePill color="yellow" v-if="currencyPoint.coins_points">
                                {{ currencyPoint.coins_points }}
                            </BadgePill>
                        </div>

                        <div>
                            <BadgePill color="red" v-if="currencyPoint.health_points">
                                {{ currencyPoint.health_points }}
                            </BadgePill>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    name: 'CurrencyPointsWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
        BadgePill,
    },
};
</script>
